import { memo } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import NetworkPing from "@mui/icons-material/NetworkPing";
import { settlePingOrder } from "features/transactions/api";
import When from "ui/support/When";
import { usePingOrder } from "./support";
import useTransactionAction from "./useTransactionAction";

const SettlePingOrder = () => {
    const {
        isLoading,
        transaction,
        request
    } = useTransactionAction();

    const { checkIfSettlePingOrderAvailable } = usePingOrder(transaction);

    const onClick = () => (
        request(() => settlePingOrder({
            ...transaction,
            coreId: transaction.pingTransactionCoreId
        }), {
            shouldNotifyOnSuccess: true
        })
    );

    return (
        <When
            if={checkIfSettlePingOrderAvailable}
            then={(
                <LoadingButton
                    data-test-id="transactions.transactionActions.settlePingOrder"
                    startIcon={(
                        <NetworkPing />
                    )}
                    onClick={onClick}
                    loading={isLoading}
                    variant='outlined'
                    size='small'
                >
                    Settle PING order
                </LoadingButton>
            )}
        />
    );
};

export default memo(SettlePingOrder);
